import { Box, styled } from '@mui/material';

export const RootBox = styled(Box)`
    display: flex;
    flex-direction: column;
`;
